module.exports = __webpack_public_path__ + "static/img/fqbg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fqbg.png
// module id = U6kF
// module chunks = 1